
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/course-collection/[slug]",
      function () {
        return require("private-next-pages/course-collection/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/course-collection/[slug]"])
      });
    }
  